/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as offerV1 from "./keyapis_subscription_offer_v1.pb"

/**
 * Сервис реализует функционал управления подписками пользователей.
 * Подписка это доступный на квартиру набор услуг на перриод времени
 */

/**
 * Сервис подписок
 */
export class SubscriptionServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения подписки.
   * Метод доступен для: admin, mrf, master, ltp_first, service, application(subscription:read или subscription:edit)
   */
  GetSubscription = (req: GetSubscriptionRequestDto, init?: RequestInit): Promise<GetSubscriptionResponseDto> => {
    return fm.request<GetSubscriptionRequestDto, GetSubscriptionResponseDto>(`${this.host}/subscription/api/v1/subscription/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка подписок.
   * Метод доступен для: admin, mrf, master, ltp_first, service, application(subscription:read или subscription:edit)
   */
  GetSubscriptionList = (req?: GetSubscriptionListRequestDto, init?: RequestInit): Promise<GetSubscriptionListResponseDto[]> => {
    return fm.list<GetSubscriptionListRequestDto, GetSubscriptionListResponseDto>(`${this.host}/subscription/api/v1/subscription/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества подписок.
   * Метод доступен для: admin, mrf, master, ltp_first, service, application(subscription:read или subscription:edit)
   */
  GetSubscriptionCount = (req?: GetSubscriptionCountRequestDto, init?: RequestInit): Promise<GetSubscriptionCountResponseDto> => {
    return fm.request<GetSubscriptionCountRequestDto, GetSubscriptionCountResponseDto>(`${this.host}/subscription/api/v1/subscription/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод смены статуса подписки.
   * Метод доступен для: admin, service, ltp_first
   */
  PostSubscriptionSetStatus = (req: PostSubscriptionSetStatusRequestDto, init?: RequestInit): Promise<PostSubscriptionSetStatusResponseDto> => {
    return fm.request<PostSubscriptionSetStatusRequestDto, PostSubscriptionSetStatusResponseDto>(`${this.host}/subscription/api/v1/subscription/${encodeURIComponent(req.id)}/set_status/${encodeURIComponent(req.statusType)}`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Типы биллинга подпискии
 */
export enum SubscriptionBillingType {
  /**
   * Значение не указано
   */
  BILLING_TYPE_UNKNOWN = "BILLING_TYPE_UNKNOWN",
  /**
   * АСР МРФ.
   * Обслуживание счетов и расчёты с клиентами происходят в АСР МРФ
   */
  ASR_MRF = "ASR_MRF",
  /**
   * АСР Ключ.
   * Обслуживание счетов и расчёты с клиентами происходят внутри Ключа
   */
  ASR_KEY = "ASR_KEY",
  /**
   * АСР УК.
   * Обслуживание счетов и расчёты с клиентами происходят во внешнем АСР от управляющей компании
   */
  ASR_MC = "ASR_MC",
}
/**
 * Типы биллинга подпискии
 */
export type SubscriptionBillingTypeResponseEnum = keyof typeof SubscriptionBillingType
/**
 * Типы биллинга подпискии
 */
export type SubscriptionBillingTypeRequestEnum = Exclude<SubscriptionBillingTypeResponseEnum, "BILLING_TYPE_UNKNOWN">;

/**
 * Типы статусов подписки
 */
export enum SubscriptionStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Настроена.
   * Подписка переведена в статус настройки.
   * Это промо-период, либо монтажник проверяет работу оборудования.
   * Услуги подписки не оплачены, но доступны для использования.
   * Финальный статус
   */
  SETUP = "SETUP",
  /**
   * Активна.
   * Подписка активирована.
   * С этого момента считаем что нужно считать денежки.
   * Услуги подписки оплачены и доступны для использования.
   * Финальный статус
   */
  ACTIVE = "ACTIVE",
  /**
   * Заблокирована.
   * Подписка фин. заблокирована.
   * Подписка в фин. блокировке.
   * Услуги подписки не оплачены и не доступны.
   * Финальный статус
   */
  BLOCKED = "BLOCKED",
  /**
   * Отменена.
   * Подписка отменена.
   * Пользователь отменил подписку.
   * Услуги подписки больше не существуют и не доступны абоненту
   */
  CANCELED = "CANCELED",
  /**
   * Запланированная отмена.
   * Пользователь решил отказаться от услуги, но уже заплатил.
   * Подписка запланирована к отмене, будет действовать до истечения срока действия в подписке.
   * Услуги подписки оплачены и доступны для использования.
   * Финальный статус
   */
  SCHEDULED_CANCELED = "SCHEDULED_CANCELED",
}
/**
 * Типы статусов подписки
 */
export type SubscriptionStatusTypeResponseEnum = keyof typeof SubscriptionStatusType
/**
 * Типы статусов подписки
 */
export type SubscriptionStatusTypeRequestEnum = Exclude<SubscriptionStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum SubscriptionPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type SubscriptionPagingDirectionTypeResponseEnum = keyof typeof SubscriptionPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type SubscriptionPagingDirectionTypeRequestEnum = Exclude<SubscriptionPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки
 */
export enum SubscriptionPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
}
/**
 * Справочник типов значений сортировки
 */
export type SubscriptionPagingOrderByTypeResponseEnum = keyof typeof SubscriptionPagingOrderByType
/**
 * Справочник типов значений сортировки
 */
export type SubscriptionPagingOrderByTypeRequestEnum = Exclude<SubscriptionPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос получения количества подписок
 */
export type GetSubscriptionCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: SubscriptionFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества подписок
 */
export type GetSubscriptionCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего подписок
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetSubscriptionCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества подписок
 */
export type GetSubscriptionCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка фильтрации подписок
   */
  readonly subscriptionFilterValidation: SubscriptionFilterValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества подписок
 */
export type GetSubscriptionCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации подписок
   */
  readonly subscriptionFilterValidation: SubscriptionFilterValidationErrorResponseDto
}>
/**
 * Запрос получения списка подписок
 */
export type GetSubscriptionListRequestDto = {
  /**
   * Фильтр
   */
  filter?: SubscriptionFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: SubscriptionPagingRequestDto
}>
/**
 * Ответ на запрос получения списка подписок
 */
export type GetSubscriptionListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Подписка
   */
  readonly data: SubscriptionResponseDto
  /**
   * Ошибка
   */
  readonly error: GetSubscriptionListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка подписки
 */
export type GetSubscriptionListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly subscriptionFilterValidation: SubscriptionFilterValidationErrorRequestDto
  /**
   * Ошибка пагинации  по страницам
   */
  readonly subscriptionPagingValidation: SubscriptionPagingValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка подписки
 */
export type GetSubscriptionListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly subscriptionFilterValidation: SubscriptionFilterValidationErrorResponseDto
  /**
   * Ошибка пагинации  по страницам
   */
  readonly subscriptionPagingValidation: SubscriptionPagingValidationErrorResponseDto
}>
/**
 * Запрос получения подписки
 */
export type GetSubscriptionRequestDto = {
  /**
   * Идентификатор подписки
   */
  id: string
}
/**
 * Ответ на запрос получения подписки
 */
export type GetSubscriptionResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Подписка
   */
  readonly data: SubscriptionResponseDto
}>
/**
 * Запрос смены статуса подписки
 */
export type PostSubscriptionSetStatusRequestDto = {
  /**
   * Идентификатор подписки.
   * Тип: Guid
   */
  id: string
  /**
   * Новый статус для подписки
   */
  statusType: SubscriptionStatusTypeRequestEnum
}
/**
 * Ответ на запрос смены статуса подписки
 */
export type PostSubscriptionSetStatusResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Подписка
   */
  readonly data: SubscriptionResponseDto
  /**
   * Ошибка
   */
  readonly error: PostSubscriptionSetStatusResponseErrorDto
}>
/**
 * Ошибка
 */
export type PostSubscriptionSetStatusResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: PostSubscriptionSetStatusResponseErrorValidationErrorRequestDto
  /**
   * Ошибка смены статуса
   */
  readonly changeStatusError: PostSubscriptionSetStatusResponseErrorChangeStatusErrorRequestDto
}>
/**
 * Ошибка
 */
export type PostSubscriptionSetStatusResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: PostSubscriptionSetStatusResponseErrorValidationErrorDto
  /**
   * Ошибка смены статуса
   */
  readonly changeStatusError: PostSubscriptionSetStatusResponseErrorChangeStatusErrorDto
}>
/**
 * Нельзя перевести подписку из текущего статуса в переданный
 */
export type PostSubscriptionSetStatusResponseErrorChangeStatusErrorRequestDto = {
  /**
   * Текущий статус
   */
  currentStatusType?: SubscriptionStatusTypeRequestEnum | "STATUS_TYPE_UNKNOWN"
  /**
   * Целевой статус
   */
  targetStatusType?: SubscriptionStatusTypeRequestEnum | "STATUS_TYPE_UNKNOWN"
}
/**
 * Нельзя перевести подписку из текущего статуса в переданный
 */
export type PostSubscriptionSetStatusResponseErrorChangeStatusErrorDto = {
  /**
   * Текущий статус
   */
  currentStatusType: SubscriptionStatusTypeResponseEnum
  /**
   * Целевой статус
   */
  targetStatusType: SubscriptionStatusTypeResponseEnum
}
/**
 * Ошибка валидации смены статуса подписки.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PostSubscriptionSetStatusResponseErrorValidationErrorRequestDto = {
  /**
   * Идентификатор передан некорректно
   */
  id?: PostSubscriptionSetStatusResponseErrorValidationErrorIdInvalidRequestDto | null
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Идентификатор передан некорректно
   */
  readonly id: PostSubscriptionSetStatusResponseErrorValidationErrorIdInvalidRequestDto
}>
/**
 * Ошибка валидации смены статуса подписки.
 * Эти проверки выполняются до обращения в базу данных
 */
export type PostSubscriptionSetStatusResponseErrorValidationErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Идентификатор передан некорректно
   */
  readonly id: PostSubscriptionSetStatusResponseErrorValidationErrorIdInvalidDto
}>
/**
 * Причины:
 * - Значение не Guid
 */
export type PostSubscriptionSetStatusResponseErrorValidationErrorIdInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение не Guid
 */
export type PostSubscriptionSetStatusResponseErrorValidationErrorIdInvalidDto = {
}
/**
 * Подписка
 */
export type SubscriptionRequestDto = {
  /**
   * Идентификатор.
   * Может быть явно задан при создании.
   * Тип: Guid
   */
  id?: string
  /**
   * ОРПОН.
   * Идентификатор дома
   */
  orpon: string
  /**
   * Номер квартиры
   */
  flatNumber: string
  /**
   * Cтатус подписки.
   * При создании может быть: SETUP, ACTIVE
   */
  statusType: SubscriptionStatusTypeRequestEnum
  /**
   * Цена
   */
  price?: number | null
  /**
   * Тип биллинга
   */
  billingType?: SubscriptionBillingTypeRequestEnum | "BILLING_TYPE_UNKNOWN"
  /**
   * Срок действия.
   * Проставляется при создании
   */
  expiredAt?: string | null
  /**
   * Идентификатор подписки, в зависимости от которой подключена данная.
   * Заполняется в подписках на опции.
   * Тип: Guid
   */
  parentId?: string | null
  /**
   * Аккаунт
   */
  account?: string | null
  /**
   * Снапшот состояния коммерческой возможности на момент создания подписки.
   * В данный момент это ссылка в базе на запись, в будущем это будет снапшот
   */
  offer?: offerV1.OfferRequestDto | null
  /**
   * Цена по скидки.
   * Заполнена если оплата подписки прошла по скидке, иначе очищается
   */
  discountPrice?: number | null
}
/**
 * Подписка
 */
export type SubscriptionResponseDto = {
  /**
   * Идентификатор.
   * Может быть явно задан при создании.
   * Тип: Guid
   */
  id: string
  /**
   * ОРПОН.
   * Идентификатор дома
   */
  orpon: string
  /**
   * Номер квартиры
   */
  flatNumber: string
  /**
   * Идентификатор коммерческой возможности(КВ).
   * Заполняется сервером на основе идентификатора из технологического плана(ТП)
   */
  readonly offerId: number
  /**
   * Cтатус подписки.
   * При создании может быть: SETUP, ACTIVE
   */
  statusType: SubscriptionStatusTypeResponseEnum
  /**
   * Предыдущий статус подписки.
   * В справочник входят только финальные статусы.
   * Заполняется сервером при изменении статусов
   */
  readonly previousStatusType: SubscriptionStatusTypeResponseEnum
  /**
   * Цена
   */
  price: number | null
  /**
   * Дата создания записи.
   * Заполняется сервером
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта
   */
  readonly changedAt: string
  /**
   * Признак для определения автоподписок.
   * Редактировать флаг запрещено.
   * Проставляется сервером в true при создании через задачу на автоподписку
   */
  readonly isEnableAutoSubscribe: boolean
  /**
   * Тип биллинга
   */
  billingType: SubscriptionBillingTypeResponseEnum
  /**
   * Срок действия.
   * Проставляется при создании
   */
  expiredAt: string | null
  /**
   * Идентификатор подписки, в зависимости от которой подключена данная.
   * Заполняется в подписках на опции.
   * Тип: Guid
   */
  parentId: string | null
  /**
   * Аккаунт
   */
  account: string | null
  /**
   * Снапшот состояния коммерческой возможности на момент создания подписки.
   * В данный момент это ссылка в базе на запись, в будущем это будет снапшот
   */
  offer: offerV1.OfferResponseDto | null
  /**
   * Цена по скидки.
   * Заполнена если оплата подписки прошла по скидке, иначе очищается
   */
  discountPrice: number | null
}
/**
 * Фильтр подписок
 */
export type SubscriptionFilterRequestDto = {
  /**
   * По ОРПОНам
   */
  orpons?: string[]
  /**
   * По номерам квартир
   */
  flatNumbers?: string[]
  /**
   * По типам биллинга
   */
  billingTypes?: SubscriptionBillingTypeResponseEnum[]
}
/**
 * Фильтр подписок
 */
export type SubscriptionFilterResponseDto = {
  /**
   * По ОРПОНам
   */
  orpons: string[]
  /**
   * По номерам квартир
   */
  flatNumbers: string[]
  /**
   * По типам биллинга
   */
  billingTypes: SubscriptionBillingTypeResponseEnum[]
}
/**
 * Ошибки валидации фильтра по подпискам.
 * Эти проверки выполняются до обращения в базу данных
 */
export type SubscriptionFilterValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Формат ОРПОН некорректен
   */
  readonly orpons: SubscriptionFilterValidationErrorOrponsInvalidRequestDto
  /**
   * Формат квартиры некорректен
   */
  readonly flatNumbers: SubscriptionFilterValidationErrorFlatNumbersInvalidRequestDto
}>
/**
 * Ошибки валидации фильтра по подпискам.
 * Эти проверки выполняются до обращения в базу данных
 */
export type SubscriptionFilterValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Формат ОРПОН некорректен
   */
  readonly orpons: SubscriptionFilterValidationErrorOrponsInvalidResponseDto
  /**
   * Формат квартиры некорректен
   */
  readonly flatNumbers: SubscriptionFilterValidationErrorFlatNumbersInvalidResponseDto
}>
/**
 * Причины:
 * - Формат квартиры некорректен (например, длина номера квартира более 4 знаков или отрицательное значение)
 */
export type SubscriptionFilterValidationErrorFlatNumbersInvalidRequestDto = {
}
/**
 * Причины:
 * - Формат квартиры некорректен (например, длина номера квартира более 4 знаков или отрицательное значение)
 */
export type SubscriptionFilterValidationErrorFlatNumbersInvalidResponseDto = {
}
/**
 * Причины:
 * - Формат ОРПОН некорректен;
 * - ОРПОН передан некорректно, к примеру, значение <= 1
 */
export type SubscriptionFilterValidationErrorOrponsInvalidRequestDto = {
}
/**
 * Причины:
 * - Формат ОРПОН некорректен;
 * - ОРПОН передан некорректно, к примеру, значение <= 1
 */
export type SubscriptionFilterValidationErrorOrponsInvalidResponseDto = {
}
/**
 * Пагинация по подпискам
 */
export type SubscriptionPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType?: SubscriptionPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: SubscriptionPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация по подпискам
 */
export type SubscriptionPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType: SubscriptionPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: SubscriptionPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Ошибка валидации постраничной пагинации по подпискам.
 * Эти проверки выполняются до обращения в базу данных
 */
export type SubscriptionPagingValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: SubscriptionPagingValidationErrorLimitInvalidRequestDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: SubscriptionPagingValidationErrorOffsetInvalidRequestDto
}>
/**
 * Ошибка валидации постраничной пагинации по подпискам.
 * Эти проверки выполняются до обращения в базу данных
 */
export type SubscriptionPagingValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: SubscriptionPagingValidationErrorLimitInvalidResponseDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: SubscriptionPagingValidationErrorOffsetInvalidResponseDto
}>
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type SubscriptionPagingValidationErrorLimitInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type SubscriptionPagingValidationErrorLimitInvalidResponseDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type SubscriptionPagingValidationErrorOffsetInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type SubscriptionPagingValidationErrorOffsetInvalidResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос получения количества подписок
   */
  "GetSubscriptionCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества подписок",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "SubscriptionFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества подписок
   */
  "GetSubscriptionCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества подписок",
    "fields": {
      /**
       * Всего подписок
       */
      "data": {
        "type": "int32",
        "text": "Всего подписок",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetSubscriptionCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества подписок
   */
  "GetSubscriptionCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества подписок",
    "fields": {
      /**
       * Ошибка фильтрации подписок
       */
      "subscriptionFilterValidation": {
        "type": "SubscriptionFilter.ValidationError",
        "text": "Ошибка фильтрации подписок",
      },
    },
  },
  /**
   * Запрос получения списка подписок
   */
  "GetSubscriptionListRequest": {
    "kind": "class",
    "text": "Запрос получения списка подписок",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "SubscriptionFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "SubscriptionPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка подписок
   */
  "GetSubscriptionListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка подписок",
    "fields": {
      /**
       * Подписка
       */
      "data": {
        "type": "Subscription",
        "text": "Подписка",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetSubscriptionListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка подписки
   */
  "GetSubscriptionListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка подписки",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "subscriptionFilterValidation": {
        "type": "SubscriptionFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
      /**
       * Ошибка пагинации  по страницам
       */
      "subscriptionPagingValidation": {
        "type": "SubscriptionPaging.ValidationError",
        "text": "Ошибка пагинации  по страницам",
      },
    },
  },
  /**
   * Запрос получения подписки
   */
  "GetSubscriptionRequest": {
    "kind": "class",
    "text": "Запрос получения подписки",
    "fields": {
      /**
       * Идентификатор подписки
       */
      "id": {
        "type": "string",
        "text": "Идентификатор подписки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения подписки
   */
  "GetSubscriptionResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения подписки",
    "fields": {
      /**
       * Подписка
       */
      "data": {
        "type": "Subscription",
        "text": "Подписка",
      },
    },
  },
  /**
   * Запрос смены статуса подписки
   */
  "PostSubscriptionSetStatusRequest": {
    "kind": "class",
    "text": "Запрос смены статуса подписки",
    "fields": {
      /**
       * Идентификатор подписки.
       * Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор подписки.\nТип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Новый статус для подписки
       */
      "statusType": {
        "type": "Subscription.StatusType",
        "text": "Новый статус для подписки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос смены статуса подписки
   */
  "PostSubscriptionSetStatusResponse": {
    "kind": "class",
    "text": "Ответ на запрос смены статуса подписки",
    "fields": {
      /**
       * Подписка
       */
      "data": {
        "type": "Subscription",
        "text": "Подписка",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostSubscriptionSetStatusResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "PostSubscriptionSetStatusResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "PostSubscriptionSetStatusResponse.Error.ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка смены статуса
       */
      "changeStatusError": {
        "type": "PostSubscriptionSetStatusResponse.Error.ChangeStatusError",
        "text": "Ошибка смены статуса",
      },
    },
  },
  /**
   * Нельзя перевести подписку из текущего статуса в переданный
   */
  "PostSubscriptionSetStatusResponse.Error.ChangeStatusError": {
    "kind": "class",
    "text": "Нельзя перевести подписку из текущего статуса в переданный",
    "fields": {
      /**
       * Текущий статус
       */
      "currentStatusType": {
        "type": "Subscription.StatusType",
        "text": "Текущий статус",
      },
      /**
       * Целевой статус
       */
      "targetStatusType": {
        "type": "Subscription.StatusType",
        "text": "Целевой статус",
      },
    },
  },
  /**
   * Ошибка валидации смены статуса подписки.
   * Эти проверки выполняются до обращения в базу данных
   */
  "PostSubscriptionSetStatusResponse.Error.ValidationError": {
    "kind": "class",
    "text": "Ошибка валидации смены статуса подписки.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Идентификатор передан некорректно
       */
      "id": {
        "type": "PostSubscriptionSetStatusResponse.Error.ValidationError.IdInvalid",
        "text": "Идентификатор передан некорректно",
      },
    },
  },
  /**
   * Причины:
   * - Значение не Guid
   */
  "PostSubscriptionSetStatusResponse.Error.ValidationError.IdInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение не Guid",
  },
  /**
   * Подписка
   */
  "Subscription": {
    "kind": "class",
    "text": "Подписка",
    "fields": {
      /**
       * Идентификатор.
       * Может быть явно задан при создании.
       * Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\nМожет быть явно задан при создании.\nТип: Guid",
      },
      /**
       * ОРПОН.
       * Идентификатор дома
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН.\nИдентификатор дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "flatNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор коммерческой возможности(КВ).
       * Заполняется сервером на основе идентификатора из технологического плана(ТП)
       */
      "offerId": {
        "type": "int32",
        "text": "Идентификатор коммерческой возможности(КВ).\nЗаполняется сервером на основе идентификатора из технологического плана(ТП)",
      },
      /**
       * Cтатус подписки.
       * При создании может быть: SETUP, ACTIVE
       */
      "statusType": {
        "type": "Subscription.StatusType",
        "text": "Cтатус подписки.\nПри создании может быть: SETUP, ACTIVE",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Предыдущий статус подписки.
       * В справочник входят только финальные статусы.
       * Заполняется сервером при изменении статусов
       */
      "previousStatusType": {
        "type": "Subscription.StatusType",
        "text": "Предыдущий статус подписки.\nВ справочник входят только финальные статусы.\nЗаполняется сервером при изменении статусов",
      },
      /**
       * Цена
       */
      "price": {
        "type": "google.protobuf.DoubleValue",
        "text": "Цена",
      },
      /**
       * Дата создания записи.
       * Заполняется сервером
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания записи.\nЗаполняется сервером",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта",
      },
      /**
       * Признак для определения автоподписок.
       * Редактировать флаг запрещено.
       * Проставляется сервером в true при создании через задачу на автоподписку
       */
      "isEnableAutoSubscribe": {
        "type": "bool",
        "text": "Признак для определения автоподписок.\nРедактировать флаг запрещено.\nПроставляется сервером в true при создании через задачу на автоподписку",
      },
      /**
       * Тип биллинга
       */
      "billingType": {
        "type": "Subscription.BillingType",
        "text": "Тип биллинга",
      },
      /**
       * Срок действия.
       * Проставляется при создании
       */
      "expiredAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Срок действия.\nПроставляется при создании",
      },
      /**
       * Идентификатор подписки, в зависимости от которой подключена данная.
       * Заполняется в подписках на опции.
       * Тип: Guid
       */
      "parentId": {
        "type": "google.protobuf.StringValue",
        "text": "Идентификатор подписки, в зависимости от которой подключена данная.\nЗаполняется в подписках на опции.\nТип: Guid",
      },
      /**
       * Аккаунт
       */
      "account": {
        "type": "google.protobuf.Int64Value",
        "text": "Аккаунт",
      },
      /**
       * Снапшот состояния коммерческой возможности на момент создания подписки.
       * В данный момент это ссылка в базе на запись, в будущем это будет снапшот
       */
      "offer": {
        "type": "Offer",
        "text": "Снапшот состояния коммерческой возможности на момент создания подписки.\nВ данный момент это ссылка в базе на запись, в будущем это будет снапшот",
      },
      /**
       * Цена по скидки.
       * Заполнена если оплата подписки прошла по скидке, иначе очищается
       */
      "discountPrice": {
        "type": "google.protobuf.DoubleValue",
        "text": "Цена по скидки.\nЗаполнена если оплата подписки прошла по скидке, иначе очищается",
      },
    },
  },
  /**
   * Фильтр подписок
   */
  "SubscriptionFilter": {
    "kind": "class",
    "text": "Фильтр подписок",
    "fields": {
      /**
       * По ОРПОНам
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОНам",
      },
      /**
       * По номерам квартир
       */
      "flatNumbers": {
        "type": "string",
        "text": "По номерам квартир",
      },
      /**
       * По типам биллинга
       */
      "billingTypes": {
        "type": "Subscription.BillingType",
        "text": "По типам биллинга",
      },
    },
  },
  /**
   * Ошибки валидации фильтра по подпискам.
   * Эти проверки выполняются до обращения в базу данных
   */
  "SubscriptionFilter.ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации фильтра по подпискам.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Формат ОРПОН некорректен
       */
      "orpons": {
        "type": "SubscriptionFilter.ValidationError.OrponsInvalid",
        "text": "Формат ОРПОН некорректен",
      },
      /**
       * Формат квартиры некорректен
       */
      "flatNumbers": {
        "type": "SubscriptionFilter.ValidationError.FlatNumbersInvalid",
        "text": "Формат квартиры некорректен",
      },
    },
  },
  /**
   * Причины:
   * - Формат квартиры некорректен (например, длина номера квартира более 4 знаков или отрицательное значение)
   */
  "SubscriptionFilter.ValidationError.FlatNumbersInvalid": {
    "kind": "class",
    "text": "Причины:\n- Формат квартиры некорректен (например, длина номера квартира более 4 знаков или отрицательное значение)",
  },
  /**
   * Причины:
   * - Формат ОРПОН некорректен;
   * - ОРПОН передан некорректно, к примеру, значение <= 1
   */
  "SubscriptionFilter.ValidationError.OrponsInvalid": {
    "kind": "class",
    "text": "Причины:\n- Формат ОРПОН некорректен;\n- ОРПОН передан некорректно, к примеру, значение <= 1",
  },
  /**
   * Пагинация по подпискам
   */
  "SubscriptionPaging": {
    "kind": "class",
    "text": "Пагинация по подпискам",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ID
       */
      "orderByType": {
        "type": "SubscriptionPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "SubscriptionPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Ошибка валидации постраничной пагинации по подпискам.
   * Эти проверки выполняются до обращения в базу данных
   */
  "SubscriptionPaging.ValidationError": {
    "kind": "class",
    "text": "Ошибка валидации постраничной пагинации по подпискам.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Количество передано некорректно
       */
      "limit": {
        "type": "SubscriptionPaging.ValidationError.LimitInvalid",
        "text": "Количество передано некорректно",
      },
      /**
       * Сдвиг передан некорректно
       */
      "offset": {
        "type": "SubscriptionPaging.ValidationError.OffsetInvalid",
        "text": "Сдвиг передан некорректно",
      },
    },
  },
  /**
   * Причины:
   * - Значение количества < 0 или > 100
   */
  "SubscriptionPaging.ValidationError.LimitInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение количества < 0 или > 100",
  },
  /**
   * Причины:
   * - Значение сдвига < 0
   */
  "SubscriptionPaging.ValidationError.OffsetInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение сдвига < 0",
  },
  /**
   * Типы биллинга подпискии
   */
  "Subscription.BillingType": {
    "kind": "enum",
    "text": "Типы биллинга подпискии",
    "values": {
      /**
       * Значение не указано
       */
      "BILLING_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * АСР МРФ.
       * Обслуживание счетов и расчёты с клиентами происходят в АСР МРФ
       */
      "ASR_MRF": {
        "i": 1,
        "text": "АСР МРФ.\nОбслуживание счетов и расчёты с клиентами происходят в АСР МРФ",
      },
      /**
       * АСР Ключ.
       * Обслуживание счетов и расчёты с клиентами происходят внутри Ключа
       */
      "ASR_KEY": {
        "i": 2,
        "text": "АСР Ключ.\nОбслуживание счетов и расчёты с клиентами происходят внутри Ключа",
      },
      /**
       * АСР УК.
       * Обслуживание счетов и расчёты с клиентами происходят во внешнем АСР от управляющей компании
       */
      "ASR_MC": {
        "i": 3,
        "text": "АСР УК.\nОбслуживание счетов и расчёты с клиентами происходят во внешнем АСР от управляющей компании",
      },
    },
  },
  /**
   * Типы статусов подписки
   */
  "Subscription.StatusType": {
    "kind": "enum",
    "text": "Типы статусов подписки",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Настроена.
       * Подписка переведена в статус настройки.
       * Это промо-период, либо монтажник проверяет работу оборудования.
       * Услуги подписки не оплачены, но доступны для использования.
       * Финальный статус
       */
      "SETUP": {
        "i": 1,
        "text": "Настроена.\nПодписка переведена в статус настройки.\nЭто промо-период, либо монтажник проверяет работу оборудования.\nУслуги подписки не оплачены, но доступны для использования.\nФинальный статус",
      },
      /**
       * Активна.
       * Подписка активирована.
       * С этого момента считаем что нужно считать денежки.
       * Услуги подписки оплачены и доступны для использования.
       * Финальный статус
       */
      "ACTIVE": {
        "i": 2,
        "text": "Активна.\nПодписка активирована.\nС этого момента считаем что нужно считать денежки.\nУслуги подписки оплачены и доступны для использования.\nФинальный статус",
      },
      /**
       * Заблокирована.
       * Подписка фин. заблокирована.
       * Подписка в фин. блокировке.
       * Услуги подписки не оплачены и не доступны.
       * Финальный статус
       */
      "BLOCKED": {
        "i": 3,
        "text": "Заблокирована.\nПодписка фин. заблокирована.\nПодписка в фин. блокировке.\nУслуги подписки не оплачены и не доступны.\nФинальный статус",
      },
      /**
       * Отменена.
       * Подписка отменена.
       * Пользователь отменил подписку.
       * Услуги подписки больше не существуют и не доступны абоненту
       */
      "CANCELED": {
        "i": 4,
        "text": "Отменена.\nПодписка отменена.\nПользователь отменил подписку.\nУслуги подписки больше не существуют и не доступны абоненту",
      },
      /**
       * Запланированная отмена.
       * Пользователь решил отказаться от услуги, но уже заплатил.
       * Подписка запланирована к отмене, будет действовать до истечения срока действия в подписке.
       * Услуги подписки оплачены и доступны для использования.
       * Финальный статус
       */
      "SCHEDULED_CANCELED": {
        "i": 5,
        "text": "Запланированная отмена.\nПользователь решил отказаться от услуги, но уже заплатил.\nПодписка запланирована к отмене, будет действовать до истечения срока действия в подписке.\nУслуги подписки оплачены и доступны для использования.\nФинальный статус",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "SubscriptionPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки
   */
  "SubscriptionPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
    },
  },
}